import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { IContainerProps } from '~/components/utils/Container';
import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';

export type IAppBreadcrumbsProps = IContainerProps & {
  appId: string;
  children?: React.ReactNode;
};

export const AppBreadcrumbs: React.FC<IAppBreadcrumbsProps> = (props) => {
  const { sx, children } = props;
  const { appId } = props;
  const appQuery = useAppQuery({ appId });

  return (
    <Breadcrumbs sx={sx}>
      <Breadcrumbs.Action href={`/apps/${appId}`}>
        <FontAwesomeIcon icon={faHouse} />
        <QuerySkeleton query={appQuery} length={{ min: 8, max: 16 }}>
          {appQuery.data?.name}
        </QuerySkeleton>
      </Breadcrumbs.Action>
      {children}
    </Breadcrumbs>
  );
};
